<template>
  <div class="insert-account">
    <custom-validate-input :label="$t('accountancy.types.labels.name')"
                           :is-empty="false"
                           :rtl="true"
                           align="right"
                           :classes="{'w-full': true}"
                           v-model="newAccount.name"/>

    <button v-show="false" id="saveBTN" @click="sendData"/>
  </div>
</template>

<script>
import CustomValidateInput from '../../../../../components/customInput/customValidateInput'
import {insertAccount} from '../../../../../http/requests/accountancy'
import axios from 'axios'

export default {
  name: 'insertAccount',
  components: {CustomValidateInput},
  props: {
    parentId: 0
  },
  data () {
    return {
      newAccount: {
        name: {}
      }
    }
  },
  methods: {
    sendData () {
      const account = {
        parent_id: this.parentId,
        name: this.newAccount.name.value
      }

      if (!account.parent_id) {
        this.$vs.notify({
          title: this.$t('alert.error.title'),
          text: this.$t('accountancy.types.notifications.parseError.parent'),
          time: 2400,
          color: 'danger',
          icon: 'icon-alert-circle',
          iconPack: 'feather'
        })
      }

      if (!account.name.length) {
        this.$vs.notify({
          title: this.$t('alert.error.title'),
          text: this.$t('accountancy.types.notifications.parseError.name'),
          time: 2400,
          color: 'danger',
          icon: 'icon-alert-circle',
          iconPack: 'feather'
        })
      }

      insertAccount(account).then(() => {
        this.$vs.notify({
          title: this.$t('alert.message.title'),
          text: this.$t('accountancy.types.notifications.insert.success'),
          time: 2400,
          color: 'success',
          icon: 'icon-check',
          iconPack: 'feather'
        })
        this.$emit('account:inserted')
        this.$store.dispatch('helper/changeAccount')
      }).catch(error => {
        if (axios.isCancel(error)) {
          this.$vs.notify({
            title: this.$t('alert.duplicateRequest.title'),
              text: this.$t('alert.duplicateRequest.message'),
            icon: 'icon-alert-circle',
            iconPack: 'feather',
            time: 2400,
            color: 'warning'
          })
        } else {
          this.$vs.notify({
            title: this.$t('alert.error.title'),
            text: this.$t('accountancy.types.notifications.insert.error'),
            time: 2400,
            color: 'danger',
            icon: 'icon-alert-circle',
            iconPack: 'feather'
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
